export const generateVirtualDialogueScriptId = (dialogueId: string, questionId: string) => {
  return `${dialogueId}_${questionId}`
}
